<div class="container">
  <span class="eyebrow">{{ 'dec.eyebrow' | traduire }}</span>
  <h2>{{ 'dec.titre' | traduire }}</h2>
  <p class="intro">{{ 'dec.intro' | traduire }}</p>

  <div class="info-grid">
    <div class="info-carte">
      <div class="icone">✈</div>
      <h4>{{ 'dec.acces.titre' | traduire }}</h4>
      <p>{{ 'dec.acces.texte' | traduire }}</p>
    </div>
    <div class="info-carte">
      <div class="icone">🏨</div>
      <h4>{{ 'dec.heberg.titre' | traduire }}</h4>
      <p>{{ 'dec.heberg.texte' | traduire }}</p>
    </div>
    <div class="info-carte">
      <div class="icone">🍽</div>
      <h4>{{ 'dec.gastro.titre' | traduire }}</h4>
      <p>{{ 'dec.gastro.texte' | traduire }}</p>
    </div>
    <div class="info-carte">
      <div class="icone">📍</div>
      <h4>{{ 'dec.visiter.titre' | traduire }}</h4>
      <p>{{ 'dec.visiter.texte' | traduire }}</p>
    </div>
  </div>

  <ng-template #iconeMeteoTpl let-icone="icone">
    <svg *ngIf="icone === 'soleil'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <circle cx="12" cy="12" r="4.5"></circle>
      <path d="M12 2.5v2.5M12 19v2.5M4.5 12H2M22 12h-2.5M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M18.4 5.6l-1.8 1.8M7.4 16.6l-1.8 1.8" stroke-linecap="round"></path>
    </svg>
    <svg *ngIf="icone === 'lune'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a6.8 6.8 0 0 0 10.5 10.5Z" stroke-linejoin="round"></path>
    </svg>
    <svg *ngIf="icone === 'nuage'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M7 18h10.5a3.5 3.5 0 0 0 .5-6.96 5 5 0 0 0-9.6-1.53A4 4 0 0 0 7 18Z" stroke-linejoin="round"></path>
    </svg>
    <svg *ngIf="icone === 'pluie'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M7 15.5h9.5a3.5 3.5 0 0 0 .5-6.96 5 5 0 0 0-9.6-1.53A4 4 0 0 0 7 15.5Z" stroke-linejoin="round"></path>
      <path d="M8 18.5l-1 2.2M12 18.5l-1 2.2M16 18.5l-1 2.2" stroke-linecap="round"></path>
    </svg>
    <svg *ngIf="icone === 'orage'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M7 14.5h9.5a3.5 3.5 0 0 0 .5-6.96 5 5 0 0 0-9.6-1.53A4 4 0 0 0 7 14.5Z" stroke-linejoin="round"></path>
      <path d="M13 15l-2.6 4.2h2.4L11 22.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
    <svg *ngIf="icone === 'neige'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M7 14.5h9.5a3.5 3.5 0 0 0 .5-6.96 5 5 0 0 0-9.6-1.53A4 4 0 0 0 7 14.5Z" stroke-linejoin="round"></path>
      <path d="M8 18v3.5M12 18v3.5M16 18v3.5M7 19.6l2-1.1M11 19.6l2-1.1M15 19.6l2-1.1" stroke-linecap="round"></path>
    </svg>
    <svg *ngIf="icone === 'brouillard'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
      <path d="M4 9.5h13M4 13h16M4 16.5h13" stroke-linecap="round"></path>
    </svg>
  </ng-template>

  <div class="meteo-transport-grid">
  <div class="meteo-carte-large">
    <p class="meteo-chargement" *ngIf="meteoChargement">{{ 'dec.meteo.chargement' | traduire }}</p>

    <ng-container *ngIf="!meteoChargement && !meteoErreur">
      <div class="meteo-actuelle">
        <div class="meteo-halo" [class.halo-nuit]="meteoIcone === 'lune'"></div>
        <span class="icone-meteo">
          <ng-container *ngTemplateOutlet="iconeMeteoTpl; context: { icone: meteoIcone }"></ng-container>
        </span>
        <div>
          <div class="temperature">{{ meteoTemperature }}°C</div>
          <div class="lieu-meteo">{{ 'dec.meteo.lieu' | traduire }}</div>
        </div>
        <p class="conseil">{{ meteoDescription }}</p>
        <p class="meteo-maj">{{ 'dec.meteo.maj' | traduire }} {{ meteoHeureMaj }} · <a (click)="chargerMeteo()">{{ 'dec.meteo.actualiser' | traduire }}</a></p>
      </div>

      <div class="meteo-semaine">
        <div class="meteo-jour" *ngFor="let j of previsionSemaine; let i = index" [style.animation-delay.ms]="i * 60">
          <span class="jour-label">{{ j.jour }}</span>
          <span class="icone-meteo-mini">
            <ng-container *ngTemplateOutlet="iconeMeteoTpl; context: { icone: j.icone }"></ng-container>
          </span>
          <span class="jour-max">{{ j.max }}°</span>
          <span class="jour-min">{{ j.min }}°</span>
        </div>
      </div>
    </ng-container>

    <div class="meteo-erreur" *ngIf="!meteoChargement && meteoErreur">
      <p>{{ 'dec.meteo.erreur' | traduire }}</p>
      <a (click)="chargerMeteo()">{{ 'dec.meteo.reessayer' | traduire }}</a>
    </div>
  </div>

  <div class="transport-bloc">
    <h3 class="titre-transport">{{ 'dec.transport.titre' | traduire }}</h3>
    <div class="transport-carte">
      <div class="transport-ligne">
        <span class="transport-icone">✈</span>
        <div>
          <b>{{ 'dec.transport.aeroport.titre' | traduire }}</b>
          <p>{{ 'dec.transport.aeroport.texte' | traduire }}</p>
        </div>
      </div>
      <div class="transport-ligne">
        <span class="transport-icone">🚄</span>
        <div>
          <b>{{ 'dec.transport.train.titre' | traduire }}</b>
          <p>{{ 'dec.transport.train.texte' | traduire }}</p>
        </div>
      </div>
      <div class="transport-ligne">
        <span class="transport-icone">🚕</span>
        <div>
          <b>{{ 'dec.transport.taxi.titre' | traduire }}</b>
          <p>{{ 'dec.transport.taxi.texte' | traduire }}</p>
        </div>
      </div>
      <div class="transport-ligne">
        <span class="transport-icone">🅿</span>
        <div>
          <b>{{ 'dec.transport.parking.titre' | traduire }}</b>
          <p>{{ 'dec.transport.parking.texte' | traduire }}</p>
        </div>
      </div>
    </div>
  </div>
  </div>

  <h3 class="titre-cout">{{ 'dec.cout.titre' | traduire }}</h3>
  <p class="intro">{{ 'dec.cout.texte' | traduire }}</p>

  <div class="cout-comparateur">
    <div class="cout-villes">
      <button *ngFor="let cle of ['paris','rome','londres','berlin']"
              [class.actif]="villeChoisie === cle"
              (click)="choisirVille(cle)">
        {{ villes[cle].label }}
      </button>
    </div>

    <div class="pieces-grille">
      <div class="piece" *ngFor="let poste of postesActuels" (click)="retournerPiece(poste)">
        <div class="piece-interieur" [class.retournee]="poste.retournee">
          <div class="piece-face piece-avant">
            <span class="piece-icone">{{ poste.icone }}</span>
            <span class="piece-label">{{ poste.label | traduire }}</span>
            <span class="piece-valeur">{{ poste.sousse }} €</span>
          </div>
          <div class="piece-face piece-arriere">
            <span class="piece-economie">−{{ pourcentageEconomie(poste) }}%</span>
            <span class="piece-valeur-arriere">{{ poste.ville }} €</span>
            <span class="piece-ville">{{ labelVille }}</span>
          </div>
        </div>
      </div>
    </div>

    <p class="astuce-piece">👆 {{ 'dec.cout.clic' | traduire }}</p>
  </div>

  <h3 class="titre-sondage">{{ 'dec.avis.titre' | traduire }}</h3>

  <p class="sondage-etat" *ngIf="sondageChargement">{{ 'dec.sondage.chargement' | traduire }}</p>

  <div class="sondage-etat-erreur" *ngIf="!sondageChargement && sondageErreur">
    <p>{{ 'dec.sondage.erreur' | traduire }}</p>
    <a (click)="chargerSondage()">{{ 'dec.meteo.reessayer' | traduire }}</a>
  </div>

  <p class="sondage-etat" *ngIf="!sondageChargement && !sondageErreur && !sondage">
    {{ 'dec.sondage.aucun' | traduire }}
  </p>

  <div class="sondage-carte" *ngIf="!sondageChargement && sondage">
    <p class="sondage-question">{{ sondage.question }}</p>

    <div class="sondage-options">
      <div class="sondage-option" *ngFor="let option of sondage.options"
           (click)="voter(option.id)"
           [class.desactivee]="aVote || sondageVoteEnCours">
        <div class="option-barre-fond">
          <div class="option-barre-remplie" *ngIf="aVote" [style.width.%]="pourcentageOption(option)"></div>
        </div>
        <div class="option-texte">
          <span>{{ option.texte }}</span>
          <span *ngIf="aVote" class="option-pourcentage">{{ pourcentageOption(option) }}%</span>
        </div>
      </div>
    </div>

    <p class="sondage-merci" *ngIf="aVote">{{ 'dec.sondage.merci' | traduire }} {{ totalVotes() }} {{ 'dec.sondage.participants' | traduire }}</p>
    <p class="sondage-note" *ngIf="!aVote">{{ sondageVoteEnCours ? ('dec.sondage.envoi' | traduire) : ('dec.sondage.note' | traduire) }}</p>
  </div>
</div>
